import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import ContactUsContent from './ContactUsContent';

import s from './ContactUsSection.module.scss';

const cx = cn.bind(s);

const defaultFormTitle = 'Can’t find the answer?';
const defaultFormText = 'Feel free to contact us and we will get back to you as soon as possible';

const Heading = ({ children, isSecondary, ...attrs }) => {
  const Tag = isSecondary ? 'h2' : 'h1';
  return <Tag className={cx('heading', { secondary: isSecondary })} {...attrs}>{children}</Tag>;
}

const ContactUsSection = ({
  children, className, formTitle = defaultFormTitle, formText = defaultFormText, isSecondary = false, ...attrs
}) => (
  <section className={cx(className, 'wrapper')} {...attrs}>
    <Heading isSecondary={isSecondary} className="text-center mb-5 tp-mobile-header-1 md:tp-tablet-header-1 lg:tp-header-1">Contact us</Heading>
    <ContactUsContent formTitle={formTitle} formText={formText} isSecondary />
  </section>
);

ContactUsSection.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ContactUsSection;
